import styled from 'styled-components';
import { ColorPalette } from 'theme/colors';

import { Card } from './components/Card/styles';

interface ContainerResultProps {
  $empty: boolean;
}

export const HeaderContainer = styled.div`
  width: 100%;
  display: flex;
  div {
    width: 100%;
  }
`;

export const Container = styled.section`
  padding-bottom: 32px;
  height: 100%;

  @media ${({ theme }) => theme.device.mobile} {
    background-color: ${ColorPalette.HEX.Lotion};
  }
`;

export const Content = styled.div`
  @media ${({ theme }) => theme.device.desktop} {
    max-width: 1300px;
  }
`;

export const ContainerResult = styled.section<ContainerResultProps>`
  min-height: 100%;

  @media ${({ theme }) => theme.device.mobile} {
    background-color: ${({ $empty }) => ($empty ? ColorPalette.Transparent : ColorPalette.HEX.White)};
    box-shadow: ${({ theme, $empty }) => ($empty ? ColorPalette.Transparent : `0 2px 20px 0 ${theme.appBar.shadow}`)};
  }
`;

export const HeaderTitle = styled.div`
  font-family: Poppins;
  display: inline;
  font-size: 16px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: 80px;
  letter-spacing: -0.2px;
  text-align: center;
  padding: 0px;
  color: ${({ theme }) => theme.simpleHeader.titleColor};
`;

export const Info = styled.div`
  font-size: 14px;
  line-height: 1.5;
  color: ${ColorPalette.HEX.DimGray};

  @media ${({ theme }) => theme.device.mobile} {
    margin: 16px;
  }
`;

export const CardList = styled.div`
  & ${Card}:last-child {
    border-bottom: 0;
  }
`;

export const CancelButton = styled.button`
  background: ${ColorPalette.Transparent};
  font-size: 16px;
  line-height: 1.5;
  color: ${ColorPalette.HEX.OriolesOrange};
  margin-left: 16px;
  cursor: pointer;
`;

export const SearchContainer = styled.div`
  display: flex;
  flex-direction: row;
  margin: 20px 16px;

  @media ${({ theme }) => theme.device.desktop} {
    margin: 20px 0;
  }
`;

export const MapBox = styled.div`
  width: 1;
  height: 1;
`;
